import Vue from "vue";
import Router from "vue-router";

import { loadLanguageAsync } from "../i18n";
import { LANG } from "@/constant";

Vue.use(Router);

const router = new Router({
  mode: "history",

  routes: [
    {
      path: '/cloudGame/:id',
      name: 'cloudGame',
      component: () => import('@/views/pages/cloudgame/CloudGame.vue'),
    },
    {
      path: '/hok/cookiesPolicy',
      component: () => import('@/views/pages/policy/CookiesPolicy.vue'),
    },
    {
      path: '/landingPage/:id',
      component: () => import('@/views/pages/landingpage/ShopPage.vue'),
    },
    {
      path: '/adPage/:id',
      component: () => import('@/views/pages/landingpage/AdPage.vue'),
    },
  ],

});

router.beforeEach(async (to, from, next) => {
  await loadLanguageAsync(LANG);
  next();
});

export default router;
